import { createColumnHelper } from "@tanstack/react-table";
import { Checkbox } from "@mui/material";
import { Eye } from "lucide-react";

const columnHelper = createColumnHelper<any>();

export const Registrar2SearchAssignedColumns = [
  columnHelper.accessor("sn", {
    header: "SN",
    cell: ({ row }) => (
      <Checkbox
        color="success"
        checked={row.getIsSelected()}
        onChange={row.getToggleSelectedHandler()}
        sx={{
          color: "#E0E0E0",
          "&.Mui-checked": {
            color: "#00B074",
          },
        }}
      />
    ),
  }),
  columnHelper.accessor("parties", {
    header: "Parties",
    cell: (info) => (
      <span
        className="text-[#101828] font-medium max-w-[260px] truncate block"
        title={info.getValue()}
      >
        {info.getValue()}
      </span>
    ),
  }),
  columnHelper.accessor("appeal_number", {
    header: "Appeal number",
    cell: (info) => (
      <span className="text-[#667085]">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("court", {
    header: "Court",
    cell: (info) => (
      <span className="text-[#667085]">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("court_number", {
    header: "Court number",
    cell: (info) => (
      <span className="text-[#667085]">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("judicial_division", {
    header: "Judicial division",
    cell: (info) => (
      <span className="text-[#667085]">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("progress", {
    header: "Progress",
    cell: (info) => (
      <span className="text-[#00B074] font-medium">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("details", {
    header: "Details",
    cell: () => (
      <div className="flex items-center gap-1 text-[#101828] cursor-pointer hover:text-[#00B074]">
        <span>View</span>
        <Eye className="w-4 h-4" />
      </div>
    ),
  }),
];

